import { from_compounded_to_separated } from './from_compounded_to_separated';
import { from_separated_to_compounded } from './from_separated_to_compounded';

export function from_compounded_to_separated_cross_check(input: string):
  [{ lyrics: string, gabc: string, nabc?: string, metadata?: string }, boolean] {
  try {
    const result = from_compounded_to_separated(input);
    const crossCheck = from_separated_to_compounded(result.lyrics, result.gabc, result.nabc);
    return [result, input !== crossCheck];
  } catch (e) {
    console.error(e);
    return [{ lyrics: 'n/a', gabc: 'n/a', nabc: 'n/a', metadata: 'n/a' }, false];
  }
}

export function from_separated_to_compounded_cross_check(
  lyrics: string, gabc: string, nabc?: string, metadata?: string):
  [string, boolean] {
  try {
    const result = from_separated_to_compounded(lyrics.trim(), gabc.trim(), nabc?.trim(), metadata?.trim());
    const crossCheck = from_compounded_to_separated(result);
    return [result, lyrics !== crossCheck.lyrics || gabc !== crossCheck.gabc || nabc !== crossCheck.nabc];
  } catch (e) {
    console.error(e);
    return ['n/a', false];
  }
}
